export default __webpack_public_path__ + "static/media/service3.f494ea1d.jpg";